import script from "./NhapKhoVatTuPhuTungPrintTemplate.vue?vue&type=script&lang=ts&setup=true"
export * from "./NhapKhoVatTuPhuTungPrintTemplate.vue?vue&type=script&lang=ts&setup=true"

import "./NhapKhoVatTuPhuTungPrintTemplate.vue?vue&type=style&index=0&id=1b6f854b&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b6f854b"]])

export default __exports__